import axios from "axios";

export const state = {
  giftCards: [],
  giftCardTiers: [],
  loadingState: [],
  searched: false
};

export const actions = {
  getGiftCards: ({ commit, dispatch }, giftCardPayload) => {
    commit("addToLoadingState", "retrieving gift cards");
    return new Promise((resolve, reject) => {
      axios.create({
        baseURL: process.env.VUE_APP_API_ALT_URL
      })
        .get(`/gift-cards/reward-issued-eligible`, {
          params: giftCardPayload
        })
        .then((resp) => {
          commit("setGiftCardsResults", resp.data);
          commit("setSearchedStatus", true);
          commit("removeFromLoadingState", "retrieving gift cards");
          resolve(resp);
        })
        .catch((err) => {
          dispatch("handleError", err.response.data.message, { root: true });
          commit("removeFromLoadingState", "retrieving gift cards");
          reject(err);
        });
    });
  },
  getGiftCardTiers: ({ commit, dispatch }) => {
    commit("addToLoadingState", "retrieving gift card tiers");
    return new Promise((resolve, reject) => {
      axios.create({
        baseURL: process.env.VUE_APP_API_ALT_URL
      })
        .get(`/global-settings/global_call_center_gift_card_tiers`)
        .then((resp) => {
          const giftCardTiers = resp.data.setting.value;
          commit("setGiftCardTiers", giftCardTiers);
          commit("removeFromLoadingState", "retrieving gift card tiers");
          resolve(resp);
        })
        .catch((err) => {
          dispatch("handleError", err, { root: true });
          commit("removeFromLoadingState", "retrieving gift card tiers");
          reject(err);
        });
    });
  },
  handleClearGiftCards: ({ commit }) => {
    commit("resetGiftCards");
  }
};

export const mutations = {
  addToLoadingState: (state, message) => {
    state.loadingState.push(message);
  },
  setGiftCardsResults: (state, giftCardResults) => {
    state.giftCards = giftCardResults;
  },
  setGiftCardTiers: (state, giftCardTiers) => {
    if (giftCardTiers) {
      state.giftCardTiers = JSON.parse(giftCardTiers);
    }
  },
  setSearchedStatus: (state, status) => {
    state.searched = true;
  },
  removeFromLoadingState: (state, message) => {
    state.loadingState = state.loadingState.filter(loadingStatus => loadingStatus !== message);
  },
  resetGiftCards: (state) => {
    state.giftCards = [];
    state.loadingState = [];
    state.searched = false;
  }
};

export default {
  state,
  actions,
  mutations
};
